import { gql } from '@apollo/client';

const BULK_LICENSE_ACTION = gql`
  mutation bulkLicenseAction(
    $where: BulkLicenseActionWhereInput
    $assignRequests: [BulkLicenseActionInput!]!
  ) {
    bulkLicenseAction(where: $where, data: $assignRequests) {
      request {
        studentId
        userId
        productId
        productCode
        orderItemId
      }
      licenses {
        id
      }
      error
    }
  }
`;

export default BULK_LICENSE_ACTION;
